// Hitos (feedback Carlos §89): vocabulario único de «qué ha pasado».
// Un cambio trae hito_id / hito_name / hito_group / severity desde la API.
// El COLOR va por GRUPO (11): identifica de qué trata el hito y ayuda a escanear.
// La SEVERIDAD (A/D/I) es urgencia de acción, NO signo de la noticia (R-18):
// se muestra como letra en chip neutro, nunca como semáforo.
import { useAuthStore } from "../store/authStore";

export type HitoFields = {
  hito_id: string | null;
  hito_name: string | null;
  hito_group: number | null;
  hito_group_name: string | null;
  severity: "A" | "D" | "I" | null;
  // Catálogo 3.9 (28 sep 2026): señales sobre agrupaciones y marca de historia
  first_competitor?: boolean;
  above_precio_menor?: boolean | null;
  historico?: boolean;
};

export type HitoCatalogItem = {
  id: string; grupo: number; grupo_nombre: string; nombre: string;
  descripcion: string | null; canal: string; aplica_a: string;
  sev: "A" | "D" | "I"; sev_propio: "A" | "D" | "I" | null; sev_competencia: "A" | "D" | "I" | null;
  activo: boolean;
  /** «Alerta crítica» de fábrica por relación (catálogo 4.4, contrato con Italfarmaco). */
  critico_propio?: boolean; critico_competencia?: boolean;
  /** ¿Lo detecta HelixScan hoy? Lo demás se enseña «sin cobertura todavía». */
  cubierto?: boolean;
  monitorizable?: string | null;
  fuentes?: string | null; frecuencia?: string | null; ventana?: string | null; disparador?: string | null;
  /** Desde cuándo vigila HelixScan el hito y con qué fuentes (Carlos, 20 oct 2026). */
  vigilado_desde?: string | null;
  fuentes_helixscan?: { code: string; name: string; desde: string | null }[];
};

export type HitoCatalog = {
  version?: string; fecha?: string;
  groups: { grupo: number; nombre: string }[]; items: HitoCatalogItem[];
};

// Paleta por grupo: 11 tonos distinguibles, ninguno reservado a «bien/mal».
export const GROUP_COLORS: Record<number, string> = {
  1:  "#0ea5e9",  // Aprobación — celeste
  2:  "#10b981",  // Financiación — esmeralda
  3:  "#ec4899",  // Comercialización — rosa
  4:  "#8b5cf6",  // Agrupaciones homogéneas y precios de referencia — violeta
  5:  "#14b8a6",  // Condiciones de financiación y dispensación — teal
  6:  "#f59e0b",  // Precios — ámbar
  7:  "#f97316",  // Seguridad — naranja
  8:  "#3b82f6",  // Mantenimiento del registro y datos técnicos — azul
  9:  "#a855f7",  // Protección y exclusividad — púrpura
  10: "#06b6d4",  // Acceso hospitalario — cian
  11: "#64748b",  // Normativo transversal — pizarra
};

/** El código del hito («PR-04») es vocabulario interno: solo lo ve el superadmin
 *  (catálogo 4.0 de Carlos). Al usuario se le enseña el nombre. */
export function useShowHitoCode(): boolean {
  return useAuthStore(s => s.user?.role) === "superadmin";
}

export function groupColor(grupo: number | null | undefined): string {
  return (grupo != null && GROUP_COLORS[grupo]) || "#94a3b8";
}

export const SEVERITIES: Array<"A" | "D" | "I"> = ["A", "D", "I"];

/** La estructura de hitos de Carlos (catálogo 4.4, Rev. 20 oct) para consulta del usuario:
 *  de dónde sale cada aviso (feedback de Carlos, 20 oct 2026). Servida como estático. */
export const ESTRUCTURA_PDF = "/docs/estructura-hitos-helixscan.pdf";
